import {
    dispatch
} from '@rematch/core';
import {
    push
} from "react-router-redux";


const initialState = {
    redirectFromDashboard: false,
    noEventDataFound: false
};

export default {
    state: initialState,
    reducers: {
        setRedirectFromDashboard(state, payload) {
            return {
                ...state,
                redirectFromDashboard: payload
            }
        },
        setNoEventDataFoundPage(state, payload) {
            return {
                ...state,
                noEventDataFound: payload
            }
        },

        clear() {
            return initialState
        }
    },

    effects: {
        clearAsync() {
            dispatch.home.clear();
        },
        redirectFromEventStream(payload) {
            dispatch.home.setRedirectFromDashboard(payload)
        },
        eventDetailsNotFound(payload) {
            dispatch.home.setNoEventDataFoundPage(payload)
        },
    }
}